import React, { useMemo } from "react";
import { groupTripRows } from "../common/groupTripRows";
import { Table } from "react-bootstrap";
import ToggleBar from "../../commoncomponents/toggleBar";
import { utcToReportDate } from "../../../utils/dateConvert";
import { downloadCSVFile } from "../../../api/apiClient";
import Location from '../../commoncomponents/location';
import { getVirtualTripInterval } from "../common/virtualTripTiming";
import ShowIButtonName from "../../commoncomponents/showIButtonName";
import { GetLocationAddress } from "../../../utils/mapapi";
import { formatTemperatureReading, temperatureReadingClass } from "../../../utils/temperature";

function VisitLog(props) {
  const report = props.reportDetail;
  const groupedRows = useMemo(() => groupTripRows(report), [report]);
  let assetName = props.assetCustomerName;
  let assetId = props.assetId;
  let timeZone = props.calendarSelectedDate ? props.calendarSelectedDate.toString().slice(25, 55) : '';
  let tempAEnabled = props.tempAEnabled;
  let tempBEnabled = props.tempBEnabled;
  let driverIDEnabled = props.driverIDEnabled;
  const lastMainTrip = report.filter((item) => !item.isSubTrip).slice(-1)[0];
  const displayParkedTime = (item, value) => (
    props.finalParkedLabel && lastMainTrip && item.tripId === lastMainTrip.tripId && (value === "00:00:00" || value === "00:00:00.0000000")
      ? props.finalParkedLabel
      : value
  );
  const driverLoginEnabled = report.some((item) => {
    const driverName = item.driverName || item.DriverName;
    return driverName && driverName.toString().trim();
  });

  const data = (
    <Table striped responsive>
      <thead>
        <tr className="nowwrapTH">
          <th>Trip ID</th>
          <th>Trip Start</th>
          <th>Trip End</th>
          <th>Parked Address</th>
          <th>Parked Time</th>
          <th>Total Parked Time </th>
          <th>Journey Time</th>
          <th>Total Journey Time</th>
          <th>Event Duration</th>
          <th>Odometer Start</th>
          <th>Odometer End</th>
          <th>End Distance</th>
          <th>Fridge</th>
          {tempAEnabled && <th>Temp A</th>}
          {tempBEnabled && <th>Temp B</th>}
          {driverIDEnabled && <th>Driver ID</th>}
          {driverLoginEnabled && <th>Driver</th>}
        </tr>
      </thead>
      <tbody>
        {groupedRows.map(({ item, groupClass, parentId }, index) => {
          const interval = getVirtualTripInterval(item);
          return (
            <tr
              key={item.tripId}
              className={`${groupClass} ${item.isInDepot ? "report-depot-row" : item.isSubTrip ? "yellowBg" : ""} ${String(props.selectedItemId) === String(item.tripId) ? "report-row-selected" : ""}`.trim()}
              onClick={() => props.onItemSelect && props.onItemSelect(item.tripId)}
              tabIndex={props.onItemSelect ? "0" : undefined}
              onKeyDown={(event) => event.key === "Enter" && props.onItemSelect && props.onItemSelect(item.tripId)}
            >
              <td>{item.tripId}{parentId && <small className="report-subset-label">Part of Trip {parentId}</small>}</td>
              <td>{utcToReportDate(interval ? interval.start : item.started)}</td>
              <td>{utcToReportDate(interval ? interval.end : item.completed)}</td>
              <td>
                <Location
                  address={item.endAddress}
                  lat={item.endLatitude}
                  lng={item.endLongitude}
                />
                {item.isInDepot && <span className="report-depot-badge">Depot</span>}
                {item.isSubTrip && <span className="report-idling-badge">Idling</span>}
              </td>
              <td>{displayParkedTime(item, item.parkedTime)}</td>
              <td>{displayParkedTime(item, item.totalParkedTime)}</td>
              <td>{item.journeyTime}</td>
              <td>{item.totalJourneyTime}</td>
              <td>{interval ? item.parkedTime : item.duration}</td>
              <td>{item.odometerStart}</td>
              <td>{item.odometerEnd}</td>
              <td>{item.endDistance}</td>
              <td>{item.fridge ? "On" : "Off"}</td>
              {tempAEnabled && <td className={temperatureReadingClass(item.tempA)}>{formatTemperatureReading(item.tempA)}</td>}
              {tempBEnabled && <td className={temperatureReadingClass(item.tempB)}>{formatTemperatureReading(item.tempB)}</td>}
              {driverIDEnabled && <td>
                  { item.driverId && 
                  <ShowIButtonName 
                  ibuttonId={item.ibuttonId}
                  serialno={item.serialno} 
                  iButtonName={item.iButtonName}
                />}
                  </td>}
              {driverLoginEnabled && <td>{item.driverName || item.DriverName || "-"}</td>}
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
  const ReportDetailWithlocation = async () =>{
    const updatedDetails = await Promise.all(
      props.reportDetail.map(async (item) => {
        if (item.startLatitude && item.startLongitude && !item.startAddress
        ) {
           const startAddress = await GetLocationAddress(item.startLatitude, item.startLongitude);
            item.startAddress = startAddress;
        }
        if (item.endLatitude && item.endLongitude && !item.endAddress
        ) {
           const endAddress = await GetLocationAddress(item.endLatitude, item.endLongitude);
            item.endAddress = endAddress;
        }  
        return item;
      })
  );
  return updatedDetails;
  }
  const handleDownloadExcel = async () => {
    let reportData = await ReportDetailWithlocation();
    // alert("clicked")
      downloadCSVFile(reportData, "Visits", assetName, timeZone, assetId);
  };
  return (
    <ToggleBar
      caption={props.caption || "Visits"}
      headerContent={props.headerContent}
      download={handleDownloadExcel}
      icon="fa-truck"
      color="#337ab7"
      content={data}
    />
  );
}

export default VisitLog;
